import { useTranslation } from 'react-i18next';
import { isNotFoundError } from '@/api/isNotFoundError';
import { Icon } from '@/components/common/Icon';
import { Button } from '@/components/ui/button';

interface QueryErrorStateProps {
  onRetry: () => void;
  error?: unknown;
}

export function QueryErrorState({ onRetry, error }: QueryErrorStateProps) {
  const { t } = useTranslation(['admin', 'common']);
  const isMissingRecord = isNotFoundError(error);

  return (
    <div className="bg-zooerrorbg border border-zooerrorborder rounded-2xl p-8 flex flex-col items-center text-center gap-2">
      <Icon name="AlertCircle" className="text-2xl text-zooerrortext" />
      <div className="text-sm font-bold text-zooerrortext">
        {isMissingRecord === true ? t('admin:errors.notFound') : t('admin:errors.loadFailed')}
      </div>
      {isMissingRecord === true ? null : (
        <Button variant="linkDanger" onClick={onRetry} className="mt-1 text-xs underline">
          {t('common:actions.retry')}
        </Button>
      )}
    </div>
  );
}
